export default "__VITE_ASSET__CcjIAv0$__"